<template>
  <div class="listing">
    <header class="header">
      <div class="header__Search">
        <form @submit.prevent="search" class="search">
          <input
            class="search__Text"
            type="search"
            :placeholder="$store.getters.getStringTranslation('enterOrgNameEnter')"
            v-model="filters.search_query"
          />
          <button class="search__Button">
            <icon name="search"></icon>
          </button>
        </form>
      </div>
    </header>
    <section class="page">
      <header class="pageHeader">
        <div class="pageHeader__Inner">
          <h1 class="pageHeader__Title">{{ $store.getters.getStringTranslation('organisations') }}</h1>
        </div>
      </header>

      <transition name="fade">
        <router-view :orgs="orgs" :queryParams="searchParams" v-if="loading === false"></router-view>
      </transition>

      <div class="tab">
        <div class="tab__MenuWrapper">
          <nav class="tab__Menu">
            <ul class="tab__MenuList--Small">
              <li v-for="item in filters.status" :key="item.id">
                <a :class="{ 'is-Active': searchParams.status === item }" @click="filter(item, 'status')"
                  >{{ $store.getters.getStringTranslation(item.toLowerCase()) }}
                  <span v-if="haveStatus(item)">({{ haveStatus(item) }})</span></a
                >
              </li>
            </ul>
          </nav>
        </div>

        <div class="tab__Wrapper">
          <div class="tab__Item">
            <div class="tab__Content">
              <table class="postsTable" :class="{ 'has-Selected': selected.length > 0 }" v-if="resources.length > 0">
                <thead>
                  <tr>
                    <th class="has-Checkbox">
                      <input type="checkbox" v-model="selectAll" id="selectAll" />
                    </th>
                    <th>{{ $store.getters.getStringTranslation('title') }}</th>
                    <th>{{ $store.getters.getStringTranslation('userRegistered') }}</th>
                    <th>{{ $store.getters.getStringTranslation('registered') }}</th>
                    <th>{{ $store.getters.getStringTranslation('lastUpdate') }}</th>
                    <!-- <th>Location</th> -->
                  </tr>
                </thead>
                <tbody>
                  <organisation
                    v-for="(item, index) in resources"
                    :key="item.id"
                    :item="item"
                    :index="index"
                    :selected="selected"
                    :orgs="orgs"
                    @input="select"
                  ></organisation>
                </tbody>
              </table>

              <div class="error" v-else-if="errors.length > 0">
                <p>Something went wrong! Please let our administrators know of the problems below.</p>

                <pre>{{ errors }}</pre>
              </div>

              <div class="error" v-else-if="resources.length === 0 && loading === false">
                <p>Sorry, no organisation matched your criteria.</p>
              </div>
            </div>
          </div>
          <loader class="imageLoader" :loading="loading" />
        </div>
      </div>

      <transition name="slideUp">
        <actions
          v-show="this.selected.length > 0"
          :selectAll="selectAll"
          :selected="selected"
          :items="resources"
          type="tag"
        ></actions>
      </transition>
    </section>
  </div>
</template>

<script>
import EventBus from '@/bus.js'

import Organisation from '@/components/listing/Organisation.vue'
import Actions from '@/components/listing/Actions.vue'
import Loader from '@/components/partials/Loader.vue'

import SelectAll from '@/components/mixins/SelectAll.js'
import Capitalize from '@/components/mixins/Capitalize.js'

export default {
  name: 'Organisations',
  components: {
    Organisation,
    Actions,
    Loader,
  },
  mixins: [SelectAll, Capitalize],
  data() {
    return {
      searchParams: {
        status: 'active',
        search_query: '',
      },
      filters: {
        status: ['active', 'pending', 'disabled'],
        search_query: '',
      },
      loading: false,
      queryParams: '',
      errors: '',
    }
  },
  created() {
    if (this.$route.params.id === undefined) {
      this.pushRoute()
    }

    EventBus.$on('clearSelected', () => {
      this.selected = []
    })
  },
  computed: {
    // Filter resources based on selected filters and search
    resources() {
      const param = this.searchParams
      const orgs = this.orgs.filter(function (a) {
        return a.status === param.status && a.full_name.toLowerCase().includes(param.search_query.toLowerCase())
      })
      return orgs
    },
    orgs() {
      return this.$store.state.accounts.orgs
    },
  },
  watch: {
    searchParams: {
      deep: true,
      handler() {
        this.selected = []
      },
    },
    'filters.search_query'(value) {
      if (value.length === 0) {
        this.search()
      }
    },
  },
  methods: {
    // Push search params to route query
    pushRoute() {
      this.selected = []
      this.$router.push({ query: { search: JSON.stringify(this.searchParams) } })
    },
    filter(value, type) {
      this.searchParams[type] = value
      this.pushRoute()
    },
    search() {
      this.searchParams.search_query = this.filters.search_query
      this.pushRoute()
    },
    haveStatus(status) {
      const orgs = this.orgs.filter((obj) => {
        return obj.status === status
      })
      return orgs.length
    },
  },
}
</script>
